import { Alert, IconDocumentBroken, Text } from 'braid-design-system';
import { useLocation } from 'react-router';
import { BasePage } from '#src/components/BasePage/BasePage.tsx';

export const ClientErrorPage = () => {
  const location = useLocation();

  return (
    <BasePage
      title={location.pathname}
      icon={<IconDocumentBroken />}
      breadcrumbs={null}
    >
      <Alert tone="caution">
        <Text>
          We encountered an error rendering this page’s content. Contact SEEK if
          the problem persists.
        </Text>
      </Alert>
    </BasePage>
  );
};
